import { render, staticRenderFns } from "./IntegratedCircuitAssessment.vue?vue&type=template&id=17643c90&scoped=true"
import script from "./IntegratedCircuitAssessment.vue?vue&type=script&lang=js"
export * from "./IntegratedCircuitAssessment.vue?vue&type=script&lang=js"
import style0 from "./IntegratedCircuitAssessment.vue?vue&type=style&index=0&id=17643c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17643c90",
  null
  
)

export default component.exports